import { Box, BoxProps, Container, ContainerProps, Stack, StackProps } from "@mui/material";
import { FC } from "react";
import { SalifyLinkV2 } from "../ui/link/link";
import { PositionAbsouteType } from "src/lib/utils/types";

interface SalifyBannerWrapperGoogleMapProps {
  latitude: number;
  longitude: number;
  zoom?: number;
  link?: any;
  content?: {
    position: PositionAbsouteType;
    stackProps: StackProps;
    containerProps: ContainerProps;
    components: any[];
  };
  cssProps?: BoxProps;
}

const SalifyBannerWrapperGoogleMap: FC<SalifyBannerWrapperGoogleMapProps> = (props) => {
  const { latitude, longitude, zoom = 15 } = props;

  // Calculate bounding box based on zoom level
  const getBoundingBox = (lat: number, lng: number, zoomLevel: number) => {
    // Convert zoom level to approximate degrees
    // Lower zoom = larger area, Higher zoom = smaller area
    const zoomFactor = Math.pow(2, 18 - zoomLevel);
    const latDelta = 0.01 * zoomFactor;
    const lngDelta = 0.01 * zoomFactor;

    return {
      minLat: lat - latDelta,
      maxLat: lat + latDelta,
      minLng: lng - lngDelta,
      maxLng: lng + lngDelta,
    };
  };

  const bbox = getBoundingBox(latitude, longitude, 20);
  const mapUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox.minLng},${bbox.minLat},${bbox.maxLng},${bbox.maxLat}&layer=mapnik&marker=${latitude},${longitude}`;

  return (
    <SalifyLinkV2 href={props.link}>
      <Box
        position="relative"
        height="300px"
        sx={{
          ":hover iframe": {
            transform: "scale(1.02)",
          },
        }}
        {...props.cssProps}
      >
        <Box
          component="iframe"
          src={mapUrl}
          loading="lazy"
          referrerPolicy="strict-origin-when-cross-origin"
          sx={{
            position: "relative",
            height: "100%",
            width: "100%",
            border: 0,
            transition: "transform 0.3s ease-in-out",
          }}
        />
      </Box>
    </SalifyLinkV2>
  );
};

SalifyBannerWrapperGoogleMap.displayName = "SalifyBannerWrapperGoogleMap";

export default SalifyBannerWrapperGoogleMap;
